import { render, staticRenderFns } from "./pageAside.vue?vue&type=template&id=6b232f5a&scoped=true"
import script from "./pageAside.vue?vue&type=script&lang=js"
export * from "./pageAside.vue?vue&type=script&lang=js"
import style0 from "./pageAside.vue?vue&type=style&index=0&id=6b232f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b232f5a",
  null
  
)

export default component.exports